<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <th style="width: 5px">Id</th>
          <th>Changed On</th>
          <th style="width: 120px">Changed By</th>
          <th style="width: 40px">Source</th>
          <th>Acc holder</th>
          <th>Acc description</th>
          <th style="width: 70px">Bank type</th>
          <th>Acc type</th>
          <th>Branch code</th>
          <th>Branch name</th>
          <th>Acc number</th>
          <th>Commission loyalty</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bankdetail of bankDetails">
          <td style="font-size: 12px">{{ bankdetail.id }}</td>
          <td style="font-size: 12px">
            {{ bankdetail.changedOn | date: "MMMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ bankdetail.changedBy }}</td>
          <td style="font-size: 12px">{{ bankdetail.source }}</td>
          <td style="font-size: 12px">{{ bankdetail.accountHolder }}</td>
          <td style="font-size: 12px">{{ bankdetail.acountDescription }}</td>
          <td style="font-size: 12px">{{ bankdetail.bankId }}</td>
          <td style="font-size: 12px">{{ bankdetail.accountTypeId }}</td>
          <td style="font-size: 12px">{{ bankdetail.branchCode }}</td>
          <td style="font-size: 12px">{{ bankdetail.branchName }}</td>
          <td style="font-size: 12px">{{ bankdetail.accountNumber }}</td>
          <td style="font-size: 12px">{{ bankdetail.commissionLoyalty }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>